import api from "../api/axios";

const PaymentService = {
  getUpcomingPayments: async (params) => {
    const response = await api.get("/Payment/upcoming", { params });
    return response.data;
  }
};

export default PaymentService;
